import {createSlice} from '@reduxjs/toolkit';

import {
    getEventsDayOverviewData,
    setSelectedDate,
    setDayOverviewData,
    finishDayOverviewRequest,
} from './day-overview-actions';
import {dayOverviewEventsAdapter} from 'pages/event-management/store/day-overview-adapters';
import type {EventDayOverviewCounts} from 'api/events/events.types';

export interface DayOverviewState {
    currentRequestId?: string;
    counts: EventDayOverviewCounts;
    error: boolean;
    events: ReturnType<typeof dayOverviewEventsAdapter.getInitialState>;
    isLoading: boolean;
    selectedDate: string;
}

export const initialState: DayOverviewState = {
    counts: {
        blackouts: 0,
        comp: null,
        dailyEvents: 0,
        employee: null,
        monthly: 0,
        transientAirport: 0,
    },
    error: false,
    events: dayOverviewEventsAdapter.getInitialState(),
    isLoading: false,
    selectedDate: '',
};

const dayOverviewSlice = createSlice({
    name: 'events/day-overview',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(setSelectedDate, (state, {payload}) => {
                state.selectedDate = payload;
            })
            .addCase(getEventsDayOverviewData.pending, (state, action) => {
                state.currentRequestId = action.meta.requestId;
                state.error = false;
                state.isLoading = true;
            })
            .addCase(setDayOverviewData, (state, {payload}) => {
                state.counts = payload.counts;
                dayOverviewEventsAdapter.setAll(state.events, payload.events);
            })
            .addCase(finishDayOverviewRequest, (state, {payload}) => {
                state.isLoading = false;
                state.error = payload.error;
            });
    },
});

export default dayOverviewSlice.reducer;
